import React, { useEffect, useState } from 'react'
import { structurePlanFeatures } from './helper'
import { subscribeIsActive } from '../Events/plans.events'
import { cross, done } from '../../../images/icon'

const FeatureList = ({layoutSettings, subscriptionPopupFonts}) => {

    const [features,setFeatures] = useState([])

    const updatefeature = (data) => {
        if (data?.planDetails?.features || data?.features) {
            setFeatures(data?.planDetails?.features || data?.features)
        }else {
            let featureList = structurePlanFeatures(data)
            setFeatures(featureList)
        }
    }

    useEffect(() => {
      subscribeIsActive(updatefeature) // subscribes to plan update for cta clicked or first time
    },[])

    let activeFeature = {
      color : layoutSettings?.featureActiveColor,
      fontSize :  subscriptionPopupFonts?.featureItemStyles?.fontSize,
      fontFamily : subscriptionPopupFonts?.featureItemStyles?.fontFamily
    }
    let inactiveFeature = {
      color : layoutSettings?.featureInactiveColor,
      fontSize :  subscriptionPopupFonts?.featureItemStyles?.fontSize,
      fontFamily : subscriptionPopupFonts?.featureItemStyles?.fontFamily
    }

  return (<>
  <div className='featurelist-wrapper'>
    {features?.map((feature) => {
      if (!feature?.featureStatus) return
        return <div className='feature-item' style={feature?.featureStatus !== "N" ? activeFeature : inactiveFeature}>
            <div className='feature-image'>{feature?.featureStatus == "Y" ? done() : feature?.featureStatus == "N" ? cross() : feature?.featureStatus}</div>
            <div className='feature-value'>{`${feature?.featureValue}`}</div>
           </div>
    })}
  </div>
  </>)
}

export default FeatureList